import logo from "assets/img/logo/logo_aig_login-2.png";
import Page from "components/Page";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select2 from "react-select";
import LoadingScreen from "react-loading-screen";
import { connect } from "react-redux";
import { Select } from "react-inputs-validation";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { Textbox } from "react-inputs-validation";
import * as Yup from 'yup';
import {
  Button, Card, CardBody, CardHeader, Col, Row,

  Input,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Popover,
  PopoverBody,
  ListGroup,
  ListGroupItem,
  Modal, ModalHeader, ModalBody, ModalFooter,
  CardFooter
} from "reactstrap";
import "../../../../styles/estilos.css";
import "../../styles/styles.scss";

import {
  MdInsertChart,
  MdPersonPin,
  MdExitToApp,
  MdFormatListBulleted,
  MdHome,
  MdArrowDropDown,
  MdLaunch,
} from "react-icons/lib/md";
import { apiGet, apiPost } from "../../../../api";
import { httpClient } from "../../../../api/httpClient";
import { ambienteAplicacion, urlFVinculacion, urlListarRenovaciones } from "../../../../constants/urls";
import moment from "moment";
import ConfirmDialog from "../../../../components/Compras/ConfirmDialog";
import { FetchExportarEccel, FetchListadoRenovaciones, validarBotonCarta, validarBotonContinuar, validarBotonFv, validarBotonRecompra, validarBotonRecotizar, validarBotonRenovar, validarCoberturaProvisional, validarPolizaVencida } from "../../redux/aRenovaciones";
import { ESTADOS_RENOVACION, RAMOS_OPTIONS, COMENTARIO_LOB, COMENTARIO_LOB_BLOQUEADOS, MENSAJES_COMENTARIO_LOB } from "../../constants/enums";
import { renovacionesColumns } from "../../constants/renovacionesColumns";
import { urlGuardarRenovaciones, urlListarTotalRenovaciones, urlSolicitarCoberturaProvicional, urlSolicitarCartaNoSiniestroa, urlConsultaFVinculacionAigPymes } from "../../api/urls";
import InputDialog from "../../../../components/Compras/InputDialog";
import { totales } from "../../../../constants";
import DataGrid from "../../../../components/DataGrid/DataGrid";
import { RAMO_ENUM } from "../../constants/ramosEnums";

class ListaRenovaciones extends React.Component {
  constructor(props) {
    super(props);
    const { datosRenovaciones } = this.props;
    this.state = {
      activePage: 1,
      renovacionesOri: datosRenovaciones.datosRenovaciones,
      datosRenovaciones: datosRenovaciones.datosRenovaciones,
      numeroElementos: datosRenovaciones.datosRenovaciones.length,
      filtro: "",
      filtrosRenovaciones: {
        "color": "",
        "marca": "",
        "nombreContratante": "",
        identificacionContratante: '',
        emailContratante: '',
        placa: '',
        marca: '',
        modelo: '',
        polDescripcionSeguro: '',
        numeroPolizaEmision: '',
        reCarritoContador: '',
        sucursal: '',
        reEstadoRenovacion: ''
      },
      filtroselect: datosRenovaciones.datosFiltroRenovaciones,
      filtroValor: "todas",
      polizaSelected: null,
      isLoadingRenovaciones: false,
      isConfirmOpen: false,
      confirmAction: null,
      titulo: '',
      isInputOpen: false,
      confirmInputAction: null,
      email: '',
      errors: null,
      message: '',
      values: {
        fechaInicio: moment().format('YYYY-MM')
      },
      totales: [],
      ramoSeleccionado: 'TODAS',
      ramosDisponibles: [],
      estadosDisponibles: []
    };

    console.log('datosRenovaciones22222', moment().format('MM-YYYY'))
  }

  param = `${this.props.datosUsuarios.brokerCodigo}&cliCodigoCore=${this.props.datosUsuarios.cliCodigoCore}`

  toggleConfirm = () => {
    this.setState((prevState) => ({
      isConfirmOpen: !prevState.isConfirmOpen,
    }));
  };

  toggleConfirmInput = () => {
    this.setState((prevState) => ({
      isInputOpen: !prevState.isInputOpen,
    }));
  };


  syncFiltersToUrl = () => {
    const { ramoSeleccionado, filtroValor, values } = this.state;
    const params = new URLSearchParams();

    if (ramoSeleccionado && ramoSeleccionado !== 'TODAS') params.set('ramo', ramoSeleccionado);
    if (filtroValor && filtroValor !== 'todas') params.set('estado', filtroValor);
    if (values.fechaInicio) params.set('fecha', values.fechaInicio);

    const newSearch = params.toString();
    if (this.props.location.search.substring(1) !== newSearch) {
      this.props.history.push({
        pathname: this.props.location.pathname,
        search: newSearch ? `?${newSearch}` : ''
      });
    }
  };

  readFiltersFromUrl = () => {
    const params = new URLSearchParams(this.props.location.search);
    const ramo = params.get('ramo') || 'TODAS';
    const estado = params.get('estado') || 'todas';
    const fecha = params.get('fecha') || moment().format('YYYY-MM');

    return { ramo, estado, fecha };
  };

  onFiltrar = async () => {
    this.syncFiltersToUrl();
    const resultado = `${moment(this.state.values.fechaInicio).format('MM-YYYY')}`;
    await this.props.listadoDeRenovaciones(this.param, ambienteAplicacion, null, resultado, this.state.filtrosRenovaciones, this.state.ramoSeleccionado);
  }

  onDescargarExcel = async () => {
    const resultado = `${moment(this.state.values.fechaInicio).format('MM-YYYY')}`;
    await this.props.descargarExcel(this.param, ambienteAplicacion, null, resultado, this.state.filtrosRenovaciones, this.props.history, this.state.ramoSeleccionado);
  }





  handleKeyDown = (event) => {

    this.onFiltrar()


    // Puedes ejecutar aquí la acción que desees al presionar Enter

  };


  handlePageChange = (pageNumber) => {

    this.setState({ activePage: pageNumber });
  };

  onSort = (event) => {

    console.log('sortedData', sortedData)
    const sortedData = [...this.state.datosRenovaciones.slice(1)].sort((a, b) => {
      let value1 = a[event.field];
      let value2 = b[event.field];

      return event.order === 1 ? value1 - value2 : value2 - value1;
    });

    console.log('sortedData', sortedData)

    // this.setState({datosRenovaciones: [{}, ...sortedData]}); // Recombina los datos manteniendo la primera fila fija
  };



  async componentDidMount() {
    // Consolidate mounting logic and sync from URL
    const urlState = this.readFiltersFromUrl();

    // Map legacy data transform
    const sanitizedData = (this.state.datosRenovaciones || []).map(item =>
      item.polDescripcionSeguro === "PITS"
        ? { ...item, polDescripcionSeguro: "PractiAuto" }
        : item
    );

    this.setState({
      datosRenovaciones: sanitizedData,
      ramoSeleccionado: urlState.ramo,
      filtroValor: urlState.estado,
      values: { ...this.state.values, fechaInicio: urlState.fecha }
    }, async () => {
      const resultado = `${moment(this.state.values.fechaInicio).format('MM-YYYY')}`;
      await this.props.listadoDeRenovaciones(this.param, ambienteAplicacion, null, resultado, {}, this.state.ramoSeleccionado);
      this.obtenerRenovaciones();
    });

    document.addEventListener('click', this.handleClickOutside, true);
  }


  ConfirmDialog = ({ isOpen, toggle, message, onConfirm }) => {
    return (
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>Confirmación</ModalHeader>
        <ModalBody>
          {message}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => { onConfirm(); toggle(); }} style={{ backgroundColor: '#001873', borderColor: '#001873' }}>
            Confirmar
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    );
  };

  /**
   * Filtra información de la tabla de a cuerdo a los filtros realizados por el usuario
   */
  handleAplicarFiltro = () => {
    let { filtro, renovacionesOri, filtroValor } = this.state;
    filtro = filtro.toUpperCase();

    const cotizaciones = renovacionesOri.filter(
      ({ polPlacas, polIdentificacionesAsegurados, polDescripcionRamo,
        fechaCreacion, nombreContratante, numeroCompra, estado, placa,
        traMetodoPago, forpago, refInterna, traEstadoPlacetoPay, numeroitems, estadoFirma, estadoInspeccion, total }) => {
        if (!polPlacas) polPlacas = "";
        if (!polIdentificacionesAsegurados) polIdentificacionesAsegurados = "";

        if (!fechaCreacion) fechaCreacion = "";
        if (!nombreContratante) nombreContratante = "";
        if (!numeroCompra) numeroCompra = "";

        if (!forpago) forpago = "";
        if (!refInterna) refInterna = "";
        if (!traEstadoPlacetoPay) traEstadoPlacetoPay = "";
        if (!estadoFirma) estadoFirma = "";
        if (!estadoInspeccion) estadoInspeccion = "";
        if (!total) total = "";

        console.log('filtroValor', filtroValor)

        const filtroEstado = filtroValor === "todas" || estado == filtroValor;

        return (
          (polPlacas.indexOf(filtro) > -1 ||
            placa.toString().indexOf(filtro) > -1 ||
            fechaCreacion.toString().indexOf(filtro) > -1 ||
            nombreContratante.indexOf(filtro) > -1 ||
            numeroCompra.toString().indexOf(filtro) > -1 ||
            //numeroitems.toString().indexOf(filtro) > -1 ||
            forpago.toString().toUpperCase().indexOf(filtro) > -1 ||
            refInterna.toString().indexOf(filtro) > -1 ||
            traEstadoPlacetoPay.indexOf(filtro) > -1 ||
            estadoFirma.indexOf(filtro) > -1 ||
            estadoInspeccion.indexOf(filtro) > -1 ||
            total.toString().indexOf(filtro) > -1 ||
            polIdentificacionesAsegurados.indexOf(filtro) > -1) &&
          filtroEstado
        );
      }
    );
    this.setState({ datosRenovaciones: cotizaciones });
  };

  componentDidUpdate(prevProps, prevState) {
    // Handle Browser Back/Forward navigation
    if (this.props.location.search !== prevProps.location.search) {
      const urlState = this.readFiltersFromUrl();
      const stateChanged = urlState.ramo !== this.state.ramoSeleccionado ||
        urlState.estado !== this.state.filtroValor ||
        urlState.fecha !== this.state.values.fechaInicio;

      if (stateChanged) {
        this.setState({
          ramoSeleccionado: urlState.ramo,
          filtroValor: urlState.estado,
          values: { ...this.state.values, fechaInicio: urlState.fecha }
        }, async () => {
          const resultado = `${moment(this.state.values.fechaInicio).format('MM-YYYY')}`;
          await this.props.listadoDeRenovaciones(this.param, ambienteAplicacion, null, resultado, this.state.filtrosRenovaciones, this.state.ramoSeleccionado);
          this.obtenerRenovaciones();
        });
      }
    }

    if (this.props.datosRenovaciones !== prevProps.datosRenovaciones) {
      const data = this.props.datosRenovaciones.datosRenovaciones || [];
      const dynamicRamos = [...new Set(data.map(item => item.polDescripcionRamo).filter(Boolean))]
        .map(ramo => ({
          label: ramo.charAt(0).toUpperCase() + ramo.slice(1).toLowerCase(),
          value: ramo
        }));

      const dynamicStates = [...new Set(data.map(item => item.estadoVer).filter(Boolean))]
        .map(estado => ({
          label: estado,
          value: estado
        }));

      this.setState({
        renovacionesOri: data,
        datosRenovaciones: data,
        numeroElementos: data.length,
        filtroselect: this.props.datosRenovaciones.datosFiltroRenovaciones,
        ramosDisponibles: dynamicRamos,
        estadosDisponibles: dynamicStates
      });
    }

    if (prevState.filtroValor !== this.state.filtroValor) {
      this.handleAplicarFiltro();
    }
  }


  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  async obtenerRenovaciones() {

    const resultado = `${moment(this.state.values.fechaInicio).format('MM-YYYY')}`;

    //return {transaccion: true}
    try {


      let ramoUrl = this.state.ramoSeleccionado;
      if (ramoUrl === 'VEHICULOS PERSONALES' || ramoUrl === 'TODAS') ramoUrl = 'VEHÍCULOS';

      const url = `${urlListarTotalRenovaciones}${this.props.datosUsuarios.brokerCodigo}&cliCodigoCore=${this.props.datosUsuarios.cliCodigoCore}&ambiente=${ambienteAplicacion}&ramo=${ramoUrl}`;
      const data = await httpClient.post(url, {
        "rangoFecha": resultado,
        "filtrosAtributos": {
          "reDatosProducto.reRamo": this.state.ramoSeleccionado === 'TODAS' ? '' : this.state.ramoSeleccionado
        }
      });

      const json = data;



      const datosFiltros = json.arrayfiltros

      const array = [
        { name: "TODAS", value: datosFiltros["TODAS"] },
        ...Object.entries(datosFiltros)
          .filter(([key]) => key !== "TODAS")
          .map(([key, value]) => ({ name: key, value }))
      ];

      console.log('resultadoRenovaciones', json.arrayfiltros, array)

      this.setState({
        totales: array
      })

      return json;
    } catch (error) {
      console.error('Error en validarSiniestralidad:', error);
      return {
        transaccion: false,
        mensaje: 'Ocurrió un problema con el servicio. Por favor, contacte a soporte técnico.'
      };
    }
  }




  textosCargando() {
    if (
      this.props.datosUsuario.usu_tipo_usuario !== undefined &&
      this.props.datosUsuario.usu_tipo_usuario !== "cliente"
    ) {
      return "Cargando Lista de Renovaciones...";
    }

    if (
      this.props.datosUsuario.usu_tipo_usuario !== undefined &&
      this.props.datosUsuario.usu_tipo_usuario === "cliente"
    ) {
      return "Cargando Lista de Renovaciones...";
    }
  }


  onClick = async (id, event, forpago) => {

    event.preventDefault();
    if (forpago !== "NI") {
      this.props.history.push({
        pathname: "/final-cotizacion-detalle",
        search: `?id=${id}&estado=APROBADO&resumen=1`, //agregar parametros de la url,
      });
    } else {
      this.props.history.push({
        pathname: "/forma-pago",
        search: `?id=${id}`, //agregar parametros de la url,
      });
    }
  };

  bodyVerEstados = (renovacion) => {

    return (
      <div>
        <p>{renovacion.estadoVer}</p>

        {
          renovacion.estado == 'PROVISIONAL_SOLICITADA' &&
          <p style={{ fontSize: 13 }}><strong>Vence: </strong> {renovacion.fechaCobertura}</p>
        }

        {
          (renovacion.estado == 'NO_SINIESTROS_FIRMADA') &&
          <p style={{ fontSize: 13 }}><strong>Vence: </strong> {renovacion.fechaCarta}</p>
        }

        {
          renovacion.ramo === 'PYMES' && (renovacion.comentarioLob || '').toLowerCase() === COMENTARIO_LOB.MODIFICAR_CONDICIONES &&
          <p style={{ fontSize: 12, color: '#e67e22', fontWeight: 'bold', marginTop: 4 }}>
            <i className="fa fa-info-circle" aria-hidden="true" style={{ marginRight: 4 }} />
            {renovacion.comentarioLob}
          </p>
        }
      </div>
    )
  }


  bodyVerDetalles = (compras) => {

    /**
    *  Ir a la pantralla de recompra
    */
    const onClickRenovacion = async () => {
      console.clear();
      this.props.history.push({
        pathname: "/renovacion",
        search: `?id=${compras.id}`,
      });
    }


    const onClickRecompra = async (id, renovacion) => {
      this.props.history.push({
        pathname: "/recompra",
        search: `?id=${id}&renovacion=${renovacion}`

      });

    }

    const onClickFV = async (renovacion) => {

      const isPymesFV = renovacion.ramo === 'PYMES' && renovacion.estado === 'FVP';
      const id = isPymesFV ? renovacion.id : renovacion.reIdCarrito;

      let fv = await obtenerFV(id, isPymesFV)

      if (fv.transaccion) {
        if (fv.pasarPantallaFormulario) {

          this.props.history.push({
            pathname: "/formulario-vinculacion-renovacion",
            search: `?url=${isPymesFV ? window.btoa(fv.urlFormulario) : fv.urlFormulario}&id=${renovacion.reIdCarrito}`,
          });
        } else {

          this.props.history.push({
            pathname: "/formulario-vinculacion-renovacion",
            search: `?haveForm=VH`,
          });
        }
      }
    }

    const obtenerFV = async (id, isPymesFV = false) => {
      try {
        const url = isPymesFV
          ? `${urlConsultaFVinculacionAigPymes}${id}`
          : `${urlFVinculacion}${id}`;
        const json = await httpClient.get(url);
        return json;
      } catch (error) {
        console.error('Error en validarSiniestralidad:', error);
        return {
          transaccion: false,
          mensaje: 'Ocurrió un problema con el servicio. Por favor, contacte a soporte técnico.'
        };
      }
    }



    const onClickContinuarProceso = async (idCarrito, anio, producto, id, aplicarRecompra = false, productoExterno = false, compras) => {

      if (compras.polDescripcionRamo && compras.polDescripcionRamo.toUpperCase() === RAMO_ENUM.PYMES) {
        this.props.history.push({
          pathname: "/datos-facturacion-pymes",
          search: `?id=${idCarrito}`
        });
        return;
      }

      const yearVariable = parseInt(anio); // Ejemplo de año en la variable
      const currentYear = moment().year(); // Obtiene el año actual con moment()

      const difference = currentYear - yearVariable;
      const bloquearFullCobertura = difference >= 15


      if (aplicarRecompra) {

        this.props.history.push({
          pathname: "/forma-pago",
          search: `?id=${idCarrito}`

        });
      } else {
        if (compras.esRecotizacion) {
          this.props.history.push({
            pathname: "/resumen-cotizacion",
            search: `?id=${idCarrito}&paso=resumen&codigoProductoEspecial=${obtenerCodigoEspecial2(compras.polDescripcionSeguroVer)}&esRenovacion=true${bloquearFullCobertura ? '&bloquearFullCobertura=true' : ''}`
          });


        } else {

          this.props.history.push({
            pathname: "/resumen-cotizacion-renovacion",
            search: `?id=${idCarrito}&paso=resumen&codigoProductoEspecial=${productoExterno ? 'externo' : producto}&esRenovacion=true${bloquearFullCobertura ? '&bloquearFullCobertura=true' : ''}`

          });

        }


      }




      const resultado = `${moment(this.state.values.fechaInicio).format('MM-YYYY')}`;

      await this.props.listadoDeRenovaciones(this.param, ambienteAplicacion, id, resultado, {}, this.state.ramoSeleccionado);




    }



    const onClickContinuarBK = async (numeroPolizaEmision, anio, renovar, codigoEspecial, id) => {
      // eslint-disable-next-line no-restricted-globals
      const answer = confirm(`¿Estás seguro de que deseas realizar la ${renovar ? 'renovación' : 'cotización'}?`)
      if (answer) {
        renovarPoliza(numeroPolizaEmision, anio, renovar, codigoEspecial, id)
      }
    }


    const onClickContinuar = (numeroPolizaEmision, anio, renovar, codigoEspecial, id, codigoEspecial2) => {
      this.setState({
        isConfirmOpen: true,
        message: `¿Estás seguro de que deseas realizar la ${renovar ? 'renovación' : 'recotización'}?`,
        confirmAction: () =>
          renovarPoliza(numeroPolizaEmision, anio, renovar, codigoEspecial, id, codigoEspecial2),
      });
    };

    const onClickContinuarSolicitarCobertura = (idRenovacion, email, renovacion) => {

      if (email) {
        this.setState({ email: email })
      } else {
        this.setState({ email: '' })
      }


      if (idRenovacion) {

        this.setState({
          titulo: 'Solicitud de cobertura provisional',
          isInputOpen: true,
          message: `¿Estás seguro de que deseas realizar la solicitud de cobertura provisional?`,
          confirmInputAction: async () => {

            let validador = await validateForm()

            console.log('validador', validador)

            if (validador) {

              solicitarCobertura(idRenovacion, this.state.email, renovacion)
              this.toggleConfirmInput()

            } else {

            }



          }
          // solicitarCarta(idRenovacion),
        });



      } else {

        this.setState({
          isConfirmOpen: true,
          message: `¿Estás seguro de que deseas realizar la solicitud de cobertura provisional?`,
          confirmAction: () =>
            solicitarCobertura(idRenovacion, email, renovacion),
        });
      }

    };

    const getSchema = () => {


      return (

        Yup.object(
          {
            email: Yup
              .string()
              .trim()
              .lowercase()
              .matches(
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                "El email no es válido"
              )
              .required("El email es obligatorio")
          }
        )

      )

    }


    const validateForm = async () => {


      try {
        await getSchema().validate({ email: this.state.email }, { abortEarly: false });
        this.setState({
          errors: null
        })
        return true;
      } catch (err) {


        const newErrors = {};
        err.inner.forEach((error) => {
          newErrors[error.path] = error.message;
        });

        console.log('newErrors', consolidateChildKeys(newErrors))

        this.setState({
          errors: newErrors.email
        })



        //  setError(consolidateChildKeys(newErrors));
        return false;
      }
    };

    function consolidateChildKeys(inputData) {
      const result = {};

      for (const key in inputData) {
        const [parentKey, childKey] = key.split('.'); // Dividir clave en padre e hijo

        if (childKey) {
          // Si es una clave hija, consolidar en el padre
          result[parentKey] = inputData[key];
        } else if (!(parentKey in result)) {
          // Si es una clave padre y aún no está consolidada, agregarla
          result[parentKey] = inputData[key];
        }
      }

      return result;
    }


    const onClickContinuarSolicitarCartaNoSiniestros = (idRenovacion, email, renovacion) => {

      if (email) {
        this.setState({ email: email })
      } else {
        this.setState({ email: '' })
      }


      if (idRenovacion) {

        this.setState({
          titulo: 'Solicitud de carta de no siniestros',
          isInputOpen: true,
          message: `¿Estás seguro de que deseas realizar la solicitud de carta de no siniestros?`,
          confirmInputAction: async () => {

            let validador = await validateForm()

            console.log('validador', validador)

            if (validador) {

              solicitarCarta(idRenovacion, this.state.email, renovacion)
              this.toggleConfirmInput()

            } else {

            }

          }
          // solicitarCarta(idRenovacion),
        });

      } else {

        this.setState({
          isConfirmOpen: true,
          message: `¿Estás seguro de que deseas realizar la solicitud de carta de no siniestros?`,
          confirmAction: () =>
            solicitarCarta(idRenovacion, email, renovacion),
        });
      }

    };


    const mostrarCobertura = (renovacion) => {
      let validador = true

      if (renovacion.procesadoCorreoCobP) {
        validador = false
      } else if (renovacion.aplicarRecompra) {
        validador = false
      }

      return validador
    }


    const mostrarCarta = (renovacion) => {
      let validador = true
      let hoy = new Date();

      if (renovacion.procesadoCorreoNoS) {
        validador = false
      } else if (!renovacion.procesadoCorreoCobP) {
        validador = false
      } else if (renovacion.aplicarRecompra) {
        validador = false
      }

      return validador
    }



    const obtenerCodigoEspecial = (producto) => {

      switch (producto) {
        case 'AIGAUTO':
          return 'AIGAUTO'
          break;
        case 'AIG AUTO':
          return 'AIGAUTO'
          break;

        case 'PRACTIAUTO':
          return 'PRACTIAUTO'
          break;


        case 'PRACTI AUTO':
          return 'PRACTIAUTO'
          break;

        default:
          return ''
          break;
      }
    }


    const obtenerCodigoEspecial2 = (producto) => {

      switch (producto) {
        case 'AIGAUTO':
          return 'comparador'
          break;
        case 'AIG AUTO':
          return 'comparador'
          break;

        case 'PRACTIAUTO':
          return 'pits'
          break;

        case 'PRACTI AUTO':
          return 'pits'
          break;

        default:
          return ''
          break;
      }
    }







    const renovarPoliza = async (numeroPolizaEmision, anio, renovar, codigoEspecial, id, codigoEspecial2) => {


      this.setState({
        isLoading: true,
        isLoadingRenovaciones: true
      })

      const yearVariable = parseInt(anio); // Ejemplo de año en la variable
      const currentYear = moment().year(); // Obtiene el año actual con moment()

      const difference = currentYear - yearVariable;
      const bloquearFullCobertura = difference >= 15


      //return console.log('yearVariable', yearVariable, currentYear, difference, bloquearFullCobertura)





      const data = await httpClient.get(`${urlGuardarRenovaciones}${numeroPolizaEmision}${!renovar ? '&esRecotizacion=true' : ''}&producto=${codigoEspecial}&renovacionId=${id} `)

      console.log('fata', data)



      if (data.transaccion) {

        if (renovar) {

          this.props.history.push({
            pathname: "/resumen-cotizacion-renovacion",
            search: `?id=${data.data.idCarrito}&paso=resumen&codigoProductoEspecial=${codigoEspecial}${renovar ? '&esRenovacion=true' : ''}${renovar && bloquearFullCobertura ? '&bloquearFullCobertura=true' : ''}`

          });

        } else {


          this.props.history.push({
            pathname: "/resumen-cotizacion",
            search: `?id=${data.data.idCarrito}&paso=resumen&codigoProductoEspecial=${codigoEspecial2}${renovar ? '&esRenovacion=true' : ''}${renovar && bloquearFullCobertura ? '&bloquearFullCobertura=true' : ''}`

          });

        }





        const resultado = `${moment(this.state.values.fechaInicio).format('MM-YYYY')}`;

        await this.props.listadoDeRenovaciones(this.param, ambienteAplicacion, id, resultado, {}, this.state.ramoSeleccionado);





      } else {
        if (data.errorDescripcion && data.errorDescripcion != '') {
          this.setState({
            tieneError: true,
            mensajeError: data.errorDescripcion
          })
        }
      }

      this.setState({
        isLoading: false,
        isLoadingRenovaciones: false
      })




    }

    const solicitarCobertura = async (idRenovacion, email = null, renovacion) => {


      this.setState({
        isLoading: true,
        isLoadingRenovaciones: true
      })




      let url = `${urlSolicitarCoberturaProvicional}${idRenovacion}${email ? `&email=${email}` : ''}${`&brokerId=${renovacion.reDatosBroker.rebrokerid}`}${`&productoId=${renovacion.reDatosProducto.reDatosVehiculo[0].reProductoCod}`}`
      let body = { emailAsesor: this.props.datosUsuarios.correo }

      const data = await httpClient.post(url, body)





      if (data.transaccion) {








      } else {
        if (data.errorDescripcion && data.errorDescripcion != '') {
          this.setState({
            tieneError: true,
            mensajeError: data.errorDescripcion
          })
        }
      }

      this.setState({
        isLoading: false,
        isLoadingRenovaciones: false
      })

      const resultado = `${moment(this.state.values.fechaInicio).format('MM-YYYY')}`;


      await this.props.listadoDeRenovaciones(this.param, ambienteAplicacion, null, resultado, this.state.filtrosRenovaciones, this.state.ramoSeleccionado);

      this.setState({
        email: ''
      })


    }



    const solicitarCarta = async (idRenovacion, email = null, renovacion) => {


      this.setState({
        isLoading: true,
        isLoadingRenovaciones: true
      })



      //return console.log('yearVariable', yearVariable, currentYear, difference, bloquearFullCobertura)


      let url = `${urlSolicitarCartaNoSiniestroa}${idRenovacion}${email ? `&email=${email}` : ''}${`&brokerId=${renovacion.reDatosBroker.rebrokerid}`}${`&productoId=${renovacion.reDatosProducto.reDatosVehiculo[0].reProductoCod}`}`
      let body = { emailAsesor: this.props.datosUsuarios.correo }

      const data = await httpClient.post(url, body)

      console.log('fata', data)



      if (data.transaccion) {










      } else {
        if (data.errorDescripcion && data.errorDescripcion != '') {
          this.setState({
            tieneError: true,
            mensajeError: data.errorDescripcion
          })
        }
      }

      this.setState({
        isLoading: false,
        isLoadingRenovaciones: false
      })

      const resultado = `${moment(this.state.values.fechaInicio).format('MM-YYYY')}`;

      await this.props.listadoDeRenovaciones(this.param, ambienteAplicacion, null, resultado, this.state.filtrosRenovaciones, this.state.ramoSeleccionado);

      this.setState({
        email: ''
      })



    }




    return (
      <div key={compras.id}>
        <Row>
          <Col sm='12'>

            {
              validarBotonRecompra(compras) &&
              <React.Fragment>

                {
                  <Button
                    className={"btn btn-primary"}
                    onClick={(e) => onClickRecompra(compras.reidPoliza, compras.id)}
                    style={{ margin: "auto", marginTop: 10, marginLeft: 0, backgroundColor: '#001873', borderColor: '#001873' }}
                  >
                    <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                    {'Recompra'}
                  </Button>

                }


              </React.Fragment>
            }

            {
              validarCoberturaProvisional(compras) &&

              <React.Fragment>

                <Button
                  className={"btn btn-primary"}
                  onClick={() => {

                    onClickContinuarSolicitarCobertura(compras.id, compras.emailContratante, compras)

                  }}
                  style={{ margin: "auto", marginTop: 10, marginLeft: 0, backgroundColor: '#001873', borderColor: '#001873' }}
                >
                  <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                  {'Solicitar Cobertura provisional'}
                </Button>
              </React.Fragment>
            }

            {
              compras.ramo === 'PYMES' && COMENTARIO_LOB_BLOQUEADOS.includes((compras.comentarioLob || '').toLowerCase()) &&
              <React.Fragment>
                <p style={{ color: '#c0392b', fontWeight: 'bold', marginTop: 10, fontSize: 13 }}>
                  <i className="fa fa-exclamation-triangle" aria-hidden="true" style={{ marginRight: 5 }} />
                  {MENSAJES_COMENTARIO_LOB[(compras.comentarioLob || '').toLowerCase()] || 'Póliza no disponible para renovación.'}
                </p>
              </React.Fragment>
            }

            {
              validarBotonCarta(compras) &&

              <React.Fragment>

                <Button
                  className={"btn btn-primary"}
                  onClick={() => {

                    onClickContinuarSolicitarCartaNoSiniestros(compras.id, compras.emailContratante, compras)
                  }}
                  style={{ margin: "auto", marginTop: 10, marginLeft: 0, backgroundColor: '#001873', borderColor: '#001873' }}
                >
                  <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                  {compras.estado == ESTADOS_RENOVACION.NO_SINIESTROS_SOLICITADA ? 'Reenviar Carta no Siniestros' : 'Solicitar Carta no Siniestros'}
                </Button>
              </React.Fragment>
            }

            {

              validarBotonRenovar(compras) &&
              //   (!compras.aplicarRecompra && (compras.estado == 'NO_SINIESTROS_FIRMADA' || compras.estado == 'Confirmación de no siniestros firmada')) &&

              <React.Fragment>

                <Button
                  className={"btn btn-primary"}
                  onClick={(e) => {
                    //  onClickContinuar(compras.numeroPolizaEmision, compras.anio, true, obtenerCodigoEspecial(compras.polDescripcionSeguro), compras.id)
                    this.props.history.push({
                      pathname: "/renovacion",
                      search: `?id=${compras.id}`

                    });

                  }
                  }
                  style={{ margin: "auto", marginTop: 10, marginLeft: 0, backgroundColor: '#001873', borderColor: '#001873' }}
                >
                  <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                  {'Gestionar renovación'}
                </Button>
              </React.Fragment>
            }

            {
              validarBotonContinuar(compras) &&

              <React.Fragment>

                <Button
                  className={"btn btn-primary"}
                  onClick={(e) => onClickContinuarProceso(compras.reIdCarrito, compras.anio, compras.reProductoNuevo, compras.id, compras.aplicarRecompra, compras.productoExterno, compras)}
                  style={{ margin: "auto", marginTop: 10, marginLeft: 0, backgroundColor: '#001873', borderColor: '#001873' }}
                >
                  <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                  {'Continuar'}
                </Button>
              </React.Fragment>
            }


            {

              validarBotonFv(compras) &&

              <Button
                className={"btn btn-primary"}
                onClick={(e) => onClickFV(compras)}
                style={{ margin: "auto", marginTop: 10, marginLeft: 0, backgroundColor: '#001873', borderColor: '#001873' }}
              >
                <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                {'Completar formulario de vinculación'}
              </Button>



            }

            {
              (validarBotonRecotizar(compras)) &&

              <React.Fragment>

                <Button
                  className={"btn btn-primary"}
                  onClick={(e) => onClickContinuar(compras.numeroPolizaEmision, compras.anio, false, obtenerCodigoEspecial(compras.polDescripcionSeguroVer), compras.id, obtenerCodigoEspecial2(compras.polDescripcionSeguroVer))}
                  style={{ margin: "auto", marginTop: 10, marginLeft: 0, backgroundColor: '#001873', borderColor: '#001873' }}
                >
                  <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                  {'Recotización'}
                </Button>
              </React.Fragment>
            }

            {
              (!compras.aplicarRecompra && (compras.estado == 'NO_RENOVADAS' || compras.estado == 'NO_RENOVABLES' || compras.estado == 'NO_RENOVABLE' || compras.estado == 'FIRMA_RECHAZADA_COBERTURA_PROVISIONAL' || compras.estado == 'FIRMA_RECHAZADA_NO_SINIESTROS')) &&
              !(compras.ramo === 'PYMES' && COMENTARIO_LOB_BLOQUEADOS.includes((compras.comentarioLob || '').toLowerCase())) &&

              <React.Fragment>

                <p>
                  {compras.mensajeNoRenovables}
                </p>
              </React.Fragment>
            }


          </Col>
        </Row>





      </div >

    );
  };

  render() {


    const { activePage, numeroElementos } = this.state;

    const fin = activePage * 10;
    const inicio = fin - 10;


    let textoBoton = "DETALLES RENOVACIÓN";
    if (
      this.props.datosUsuario.usu_tipo_usuario &&
      this.props.datosUsuario.usu_tipo_usuario !== "cliente"
    ) {
      textoBoton = "DETALLES RENOVACIÓN";
    }

    const {
      filtroselect,
      filtroValor,
      ramoSeleccionado
    } = this.state;

    return (
      <LoadingScreen
        loading={this.props.datosRenovaciones.isLoadingRenovaciones || this.state.isLoadingRenovaciones}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text={this.textosCargando()}
      >
        <Page
          title={
            this.props.datosUsuario.usu_tipo_usuario &&
              this.props.datosUsuario.usu_tipo_usuario !== "cliente"
              ? "Listado de Renovaciones"
              : "Listado de Renovaciones"
          }
          breadcrumbs={[
            {
              name:
                this.props.datosUsuario.usu_tipo_usuario &&
                  this.props.datosUsuario.usu_tipo_usuario !== "cliente"
                  ? "Listado de Renovaciones"
                  : "Listado de Renovaciones",
              active: true,
            },
          ]}
        >
          <Row className="px-3">
            {Array.isArray(this.state.totales) && [...this.state.totales]
              .sort((a, b) => (b.value || 0) - (a.value || 0))
              .map((item, index) => {
                const isSelected = this.state.filtroValor === item.id;
                return (
                  <Col key={index} xl={true} lg={2} md={4} sm={6} xs={6} className="mb-4 px-2">
                    <Card
                      className="h-100 border-0 shadow-sm"
                      style={{
                        borderRadius: "15px",
                        cursor: "pointer",
                        transition: "all 0.2s ease-in-out",
                        border: isSelected ? '2px solid #001873' : '1px solid transparent',
                        backgroundColor: isSelected ? '#f1f4ff' : '#ffffff',
                        transform: isSelected ? 'translateY(-3px)' : 'none'
                      }}
                      onClick={() => {
                        this.setState({ filtroValor: item.id }, () => {
                          this.syncFiltersToUrl();
                        });
                      }}
                    >
                      <CardBody className="p-3 d-flex flex-column align-items-center justify-content-center text-center">
                        <div style={{
                          fontSize: "0.65rem",
                          fontWeight: "800",
                          color: isSelected ? "#001873" : "#6c757d",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                          marginBottom: "8px",
                          minHeight: "2.5em",
                          display: "flex",
                          alignItems: "center"
                        }}>
                          {item.name}
                        </div>
                        <div style={{
                          fontSize: "2.2rem",
                          fontWeight: "900",
                          color: "#001873",
                          lineHeight: "1"
                        }}>
                          {item.value !== undefined ? item.value : 0}
                        </div>
                        {isSelected && (
                          <div style={{
                            width: '15px',
                            height: '3px',
                            backgroundColor: '#001873',
                            borderRadius: '10px',
                            marginTop: '6px'
                          }} />
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                )
              })}
          </Row>




          <Card className="mb-4 shadow-sm border-0" style={{ borderRadius: '15px' }}>
            <CardBody className="p-4">
              <Row className="align-items-start">
                <Col lg={3} md={6}>
                  <div className="form-group mb-0">
                    <label htmlFor="fecha-filter" style={{ fontWeight: 'bold', fontSize: '0.85rem', marginBottom: '8px', display: 'block', color: '#001873' }}>RANGO DE FECHAS</label>
                    <div className="datepicker-wrapper">
                      <style>{`
                        .datepicker-wrapper .react-datepicker-wrapper {
                          display: block;
                          width: 100%;
                        }
                        .datepicker-wrapper .form-control {
                          height: 40px !important;
                          border-radius: 10px !important;
                          border: 1px solid #ced4da !important;
                          padding-left: 15px !important;
                          padding-right: 35px !important;
                          width: 100% !important;
                          background-color: #ffffff !important;
                          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23001873' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E") !important;
                          background-repeat: no-repeat !important;
                          background-position: right 12px center !important;
                          background-size: 14px !important;
                          font-size: 0.9rem !important;
                          color: #495057 !important;
                          cursor: pointer !important;
                        }
                        .datepicker-wrapper .form-control:focus {
                          outline: none !important;
                          box-shadow: none !important;
                          border-color: #001873 !important;
                        }
                      `}</style>
                      <DatePicker
                        selected={this.state.values.fechaInicio ? moment(this.state.values.fechaInicio, 'YYYY-MM').toDate() : null}
                        onChange={(date) => {
                          this.setState({
                            values: { ...this.state.values, fechaInicio: moment(date).format('YYYY-MM') }
                          });
                        }}
                        dateFormat="MM/yyyy"
                        showMonthYearPicker
                        className="form-control"
                        placeholderText="Seleccione Mes"
                        id="fecha-filter"
                        wrapperClassName="w-100"
                      />
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6}>
                  <div className="form-group mb-0">
                    <label htmlFor="ramo-filter" style={{ fontWeight: 'bold', fontSize: '0.85rem', marginBottom: '8px', display: 'block', color: '#001873' }}>RAMO</label>
                    <Select2
                      id="ramo-filter"
                      value={RAMOS_OPTIONS.find(opt => opt.value === ramoSeleccionado)}
                      options={RAMOS_OPTIONS}
                      isSearchable={false}
                      onChange={async (selectedOption) => {
                        const newRamo = selectedOption.value;
                        this.setState({ ramoSeleccionado: newRamo }, async () => {
                          this.syncFiltersToUrl();
                          const resultado = `${moment(this.state.values.fechaInicio).format('MM-YYYY')}`;
                          await this.props.listadoDeRenovaciones(this.param, ambienteAplicacion, null, resultado, this.state.filtrosRenovaciones, newRamo);
                          this.obtenerRenovaciones();
                        });
                      }}
                      placeholder="Seleccione Ramo"
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: '40px',
                          height: '40px',
                          borderRadius: '10px',
                          border: state.isFocused ? '1px solid #001873' : '1px solid #ced4da',
                          boxShadow: 'none',
                          cursor: 'pointer',
                          backgroundColor: '#ffffff',
                          '&:hover': {
                            border: state.isFocused ? '1px solid #001873' : '1px solid #ced4da'
                          }
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          padding: '0 15px',
                          height: '38px',
                          display: 'flex',
                          alignItems: 'center'
                        }),
                        singleValue: (base) => ({
                          ...base,
                          fontSize: '0.9rem',
                          color: '#495057'
                        }),
                        indicatorsContainer: (base) => ({
                          ...base,
                          height: '38px'
                        }),
                        dropdownIndicator: (base) => ({
                          ...base,
                          padding: '8px',
                          color: '#001873'
                        }),
                        indicatorSeparator: () => ({
                          display: 'none'
                        }),
                        placeholder: (base) => ({
                          ...base,
                          fontSize: '0.9rem'
                        })
                      }}
                    />
                  </div>
                </Col>
                <Col lg={6} md={12} className="text-lg-right text-left mt-3 mt-lg-0">
                  <div style={{ height: '28px' }} className="d-none d-lg-block"></div>
                  <div className="d-flex justify-content-lg-end">
                    <Button
                      color={"#001873"}
                      className="shadow-sm mr-2"
                      style={{ borderRadius: '8px', height: '40px', padding: '0 25px', fontWeight: 'bold', backgroundColor: '#001873', borderColor: '#001873', color: '#fff' }}
                      onClick={() => this.onFiltrar()}
                    >
                      <i className="fa fa-filter mr-2" aria-hidden="true" /> FILTRAR
                    </Button>
                    <Button
                      color={"#001873"}
                      className="shadow-sm"
                      style={{ borderRadius: '8px', height: '40px', padding: '0 25px', fontWeight: 'bold', backgroundColor: '#001873', borderColor: '#001873', color: '#fff' }}
                      onClick={() => this.onDescargarExcel()}
                    >
                      <i className="fa fa-download mr-2" aria-hidden="true" /> EXPORTAR A EXCEL
                    </Button>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Row>
            <Col>
              <Card body className="border-0 shadow-sm" style={{ borderRadius: '15px' }}>
                <DataGrid
                  data={this.state.datosRenovaciones}
                  rows={10}
                  responsive={true}
                  columns={renovacionesColumns(this)}
                />
              </Card>
            </Col>
          </Row>

          {this.state.datosRenovaciones.length === 0 && (
            <Row>
              <Col
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="detalle-cotizacion-box"
              >
                <Card className="mb-3">
                  <CardHeader style={{ borderBottom: "none" }}></CardHeader>
                  <CardBody>
                    <h2 style={{ color: "#001873", textAlign: "center" }}>
                      {" "}
                      NO SE HA ENCONTRADO REGISTROS DE RENOVACIONES
                    </h2>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          <ConfirmDialog
            isOpen={this.state.isConfirmOpen}
            toggle={this.toggleConfirm}
            message={this.state.message}
            onConfirm={() => {
              if (this.state.confirmAction) this.state.confirmAction();
            }}
          />


          <InputDialog
            titulo={this.state.titulo}
            isOpen={this.state.isInputOpen}
            toggle={this.toggleConfirmInput}
            email={this.state.email}
            setEmail={(email) => this.setState({ email: email })}
            error={this.state.errors}
            onConfirm={() => {
              if (this.state.confirmInputAction) this.state.confirmInputAction();
            }}
          />
        </Page>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = (state) => ({
  datosRenovaciones: state.dataRenovaciones,
  datosUsuario: state.datosUsuarios.dataUsuario,
  datosUsuarios: state.datosUsuarios.dataUsuario,
});

const mapDispatchToProps = (dispatch) => {
  return {
    listadoDeRenovaciones: (param, ambiente, id, rangoFecha, filtros, ramo) => dispatch(FetchListadoRenovaciones(param, ambiente, id, rangoFecha, filtros, ramo)),
    descargarExcel: (param, ambiente, id, rangoFecha, filtros, history, ramo) => dispatch(FetchExportarEccel(param, ambiente, id, rangoFecha, filtros, history, ramo)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ListaRenovaciones)
);

